function addCart(data,$this){
  let hederT = $(".site-header__cart-indicator");
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(line_item) {
      $.getJSON('/cart',function(data){
        var count = data.item_count;
        $(".cart_count").html(count);
      })
      $this.text('Add To Cart');
    },
    error: function(error) {
      console.log(error)
    }
  };
  jQuery.ajax(params);
}

$(document).on('click','.addBtnWrap button', function(e){
  e.preventDefault();
  let $this = $(this);
  let id = $this.parents('.product-card__overlay').find('.vId').val();
  id = parseInt(id);
  let qty = 1;

  let data = {
    id: id,
    quantity: qty
  };

  if($this.hasClass('addToCart')){
    $this.text('Adding...');
    addCart(data,$this)
  }
  else if($this.hasClass('buynow')){
    location.href = "https://www.gudness.co.uk/cart/"+id+":"+qty
  }
})